import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIssueCommentAttachment } from '@/api/model/interfaces';

export default class DrawingPackageIssueCommentAttachmentOdata extends OdataManager<DrawingPackageIssueCommentAttachment> {}
